import type { EpgInfo } from '@setplex/tria-api'
import type { EpgRequestParams } from '../index.h'

import { api } from '@setplex/tria-api'
import { attach, createEvent, createStore, sample } from 'effector'
import {
  formatEpgRequestToFetchParams,
  formatProgramEpgToFetchParams,
  markChannelsEpgAsPending,
  unmarkChannelsEpgAsPending,
} from '../lib'
import { isValidRange } from '../lib/ranges'

// event to guard calling actual fetch, in case of bad params
export const fetchEpgInfo = createEvent<EpgRequestParams>()

// event to fetch upcoming epg data
export const fetchProgramEpg = createEvent<EpgInfo>()

// actual fetch epg data effect
export const fetchEpgInfoFx = attach({
  effect: api.tv.getEpgInformationFormattedAbortableFx,
})

export const $pendingByEpgId = createStore<[Map<string, number>]>([new Map()])

// actual fetch upcoming epg data effect
export const fetchProgramEpgFx = attach({
  effect: api.tv.getProgramEPGInfoAbortableFx,
})

// fetch epg data for channels for biggest calculated range
sample({
  clock: fetchEpgInfo,
  filter: ({ channels, period }) => channels.length > 0 && isValidRange(period),
  fn: formatEpgRequestToFetchParams,
  target: fetchEpgInfoFx,
})

sample({
  clock: fetchEpgInfoFx,
  source: $pendingByEpgId,
  fn: markChannelsEpgAsPending,
  target: $pendingByEpgId,
})

sample({
  clock: fetchEpgInfoFx.finally,
  source: $pendingByEpgId,
  fn: unmarkChannelsEpgAsPending,
  target: $pendingByEpgId,
})

// fetch upcoming data by given epg program
sample({
  clock: fetchProgramEpg,
  fn: formatProgramEpgToFetchParams,
  target: fetchProgramEpgFx,
})
